<template>
  <section>
    <div class="d-flex justify-content-center hv-100" >
      <div class="container-fluid hv-100">
        <div class="row hv-100 mobile-100">
          <div class="d-flex flex-row align-items-center col-sm-12 col-lg-7 bg-white mobile-100">
            <div class="col-md-6 offset-md-3">
              <div class="login-header text-center">
                <h2 class="login-title my-1">{{ $t("lang.label.welcomeback") }}</h2>
                <p class="login-subtitle text-secondary mb-3">{{ $t("lang.label.login-welcomeback-message") }}</p>
              </div>
              <span class="alert alert-success mt-2" v-if="codeverification">{{codeverification}}</span>
              <LoadingSpinnerBar v-if="loading" />
              <div v-if="!loading">
                <div
                  v-if="alert.message && !submittedSecond"
                  :class="`login-alert alert ${alert.type}`"
                  v-html="alert.message"
                ></div>
              </div>
              <div v-if="!loading">
                <div v-if="alert.message && submittedSecond">
                  <AlertError :msgError="alert.message" />
                </div>
              </div>
              <form
                @submit.prevent="handleSubmit"
                class="login-form text-left"
                v-if="!loading"
              >
                <div class="input-wrapper">
                  <label class="text-dark" for="username">{{ $t("lang.label.email") }} <span class="label-required">*</span></label>
                  <input
                    type="text"
                    v-model="username"
                    name="username"
                    class="form-control"
                    placeholder="john.doe@oliverlist.com"
                    :class="{ 'is-invalid': submitted && !username }"
                  />
                  <div v-show="submitted && !username" class="invalid-feedback">
                    {{ $t("lang.label.usernamerequired") }}
                  </div>
                </div>
                <div class="input-wrapper">
                  <label class="text-dark" for="pass">{{ $t("lang.label.password") }} <span class="label-required">*</span></label>
                  <input
                    type="password"
                    v-model="password"
                    name="password"
                    class="form-control"
                    placeholder="********"
                    :class="{ 'is-invalid': submitted && !password }"
                  />
                  <small>Forgot your password? </small>
                  <span>
                    <small class="text-primary">
                      <router-link to="/lostpassword" class="nav-link pxmd-0 px-2">{{ $t('lang.label.login-click-here')}}</router-link>
                    </small>
                  </span>
                  <div v-show="submitted && !password" class="invalid-feedback">
                    {{ $t("lang.label.passwordrequired") }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-sx-12 col-md-12">
                    <button
                      class="btn btn-primary  btn-block themed-button btn-md"
                      :disabled="loggingIn"
                    >
                      {{ $t("lang.button.login") }}
                    </button>
                  </div>
                  <div class="col-sx-12 col-md-12 col-lg-12 my-4 mymd-4 text-center">
                    <small>{{
                          $t("lang.label.donthaveanaccount")
                        }}
                    </small>
                    <span>
                      <small class="text-primary">
                        <router-link to="/createaccount">
                           {{ $t("lang.label.login-click-here") }}
                        </router-link>
                      </small>
                    </span>
                  </div>
                </div>
              </form>

            </div>
          </div>
          <Features />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LoadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";
import AlertError from "@/components/AlertError.vue";
import Features from "@/components/AccountCreation/Steps/Features.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      submittedSecond: false,
      codeverification:false
    };
  },
  components: {
    LoadingSpinnerBar,
    AlertError,
    Features
  },
  computed: {
    ...mapState({
      loading: (state) => state.authentication.status.loggingIn,
    }),
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    },
  },
  created() {
    if(this.$route.query.successcode !== undefined){
      this.codeverification = this.$t('lang.accountcreation.verificationsuccess')
    }

    if(this.$route.query.user !== undefined){
      this.username = this.$route.query.user;
    }
    if(this.$route.query.pass !== undefined){
      this.password = this.$route.query.pass;
    }
    // reset login status
    this.$store.dispatch("authentication/logout");
    this.$store.dispatch("opportunities/resetState");
    this.$store.dispatch("alert/clear");
  },
  methods: {
    handleSubmit(e) {
      if (!this.submitted) {
        this.submitted = true;
      } else {
        this.submittedSecond = true;
      }
      const { username, password } = this;
      const { dispatch } = this.$store;
      if (username && password) {
        dispatch("authentication/login", { username, password }).then(
          (result) => {
            this.$router.push("/");
          }
        );
      }
    },
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    },
    username() {
      this.username = this.$sanitize(this.username);
    },
  },
};
</script>
<style>
.color-red {
  color: #721c24;
}

@media only screen and (max-width: 600px) {
  .mobile-100 {height:100vh}
}

@media (max-width: 991px) {
  .mymd-4 {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .pxmd-0 {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}

.login-header {
  text-align: center;
}
.login-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #000;
}
.login-subtitle {
  font-size: 0.95rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}
.label-required {
  color: #dc3545;
}
</style>
